<template>
  <div class="flex flex-col">
    <TableDocs type="Note de credit" api-type="credit-notes" number-prefix="NC" />
  </div>
</template>

<script>
import TableDocs from '@/components/Table/Docs'

export default {
  components: {
    TableDocs,
  },
  theme() {
    return {
      title: 'Notes de credit',
      buttons: [
        {
          to: '/credit-notes/add',
          label: '+ Ajouter note de credit',
        },
      ],
    }
  },
}
</script>

<style></style>
